import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  ScrollView,
  Dimensions,
} from "react-native";
import React, { useState } from "react";
import AppFonts from "../../../Constants/AppFonts";
import AppImages from "../../../Constants/AppImages";
import AppColors from "../../../Constants/AppColors";

// import MapView, { Circle, Marker, PROVIDER_GOOGLE } from "react-native-maps";
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";

import AllParkingStation from "./AllParkingStation";
import SugestedParkStation from "./SugestedParkStation";
import Appstyles from "../../../Constants/AppStyles";
import TopTabs from "../../../Components/TopTabs";

const { width, height } = Dimensions.get("window");
const Tab = createMaterialTopTabNavigator();
const ParkStation = ({ navigation }) => {
  const [selectedBox, setSelectedBox] = useState(0);
  const handleBoxPressbtn = (index) => {
    setSelectedBox(index);
  };
  //------Map-----------//
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [markerLocations, setMarkerLocations] = useState([]);

  const handleMapPress = (event) => {
    const { coordinate } = event.nativeEvent;
    setSelectedLocation(coordinate);
    setMarkerLocations([...markerLocations, coordinate]);
  };

  return (
    <SafeAreaView style={Appstyles.safe7}>
      <View style={Appstyles.HeaderMain}>
        <View style={Appstyles.HeaderSec}>
          <TouchableOpacity
            style={Appstyles.Arrowstyle}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={Appstyles.ArrowImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <Text style={Appstyles.HeaderText}>Parking Station</Text>
        </View>
        <View style={Appstyles.rc}>
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={Appstyles.BellImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate("ParkingDetails")}
          >
            <Image
              source={AppImages.Plus}
              style={Appstyles.PlusImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <View style={{ flex: 1, marginTop: 10 }}>
        <TopTabs
          scrollable
          tabs={[
            {
              label: "All",
              render: () => <AllParkingStation navigation={navigation} />,
            },
            {
              label: "Suggested Parking Station",
              render: () => <SugestedParkStation navigation={navigation} />,
            },
          ]}
        />
      </View>
      {false && (
      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
        showsVerticalScrollIndicator={false}
      >
        {/* <View style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
          <View style={{ backgroundColor: AppColors.white, flex: 1 }}>
            {selectedBox === 0 ? (
              <View style={styles.hjhah}>
                <View style={styles.mam}>
                  <View style={styles.hjnshj}></View>
                  <MapView
                    style={styles.fleee}
                    provider={PROVIDER_GOOGLE}
                    showsUserLocation
                    initialRegion={{
                      latitude: 37.78825,
                      longitude: -122.4324,
                      latitudeDelta: 0.0922,
                      longitudeDelta: 0.0421,
                    }}
                    onPress={handleMapPress}
                  >
                    {markerLocations.map((location, index) => (
                      <Marker
                        key={index}
                        coordinate={location}
                        title={`Marker ${index + 1}`}
                        // description="Marker Description"
                      >
                        <Image
                          source={AppImages.ParkingMarker}
                          style={{ width: 24, height: 24 }}
                          resizeMode="contain"
                        />
                      </Marker>
                    ))}
                    {selectedLocation && (
                      <Circle
                        center={selectedLocation}
                        radius={3000} // Specify the radius of the circle in meters
                        strokeColor="rgba(66, 31, 0, 0.3)" // Set the stroke color and opacity
                        fillColor="rgba(66, 31, 0, 0.3)" // Set the fill color and opacity
                      />
                    )}
                  </MapView>
                </View>
              </View>
            ) : null}

            {selectedBox === 1 ? (
              <View style={styles.hjhah}>
                <View style={styles.mam}>
                  <View style={styles.hjnshj}></View>
                  <MapView
                    style={styles.fleee}
                    provider={PROVIDER_GOOGLE}
                    showsUserLocation
                    initialRegion={{
                      latitude: 37.78825,
                      longitude: -122.4324,
                      latitudeDelta: 0.0922,
                      longitudeDelta: 0.0421,
                    }}
                    onPress={handleMapPress}
                  >
                    {selectedLocation && (
                      <Circle
                        center={selectedLocation}
                        radius={3000} // Specify the radius of the circle in meters
                        strokeColor="rgba(66, 31, 0, 0.3)" // Set the stroke color and opacity
                        fillColor="rgba(66, 31, 0, 0.3)" // Set the fill color and opacity
                      />
                    )}
                  </MapView>
                </View>
              </View>
            ) : null}

            <View style={{ flex: 1 }}>
              <Tab.Navigator
                screenOptions={{
                  tabBarIndicatorStyle: {
                    backgroundColor: "#8F4300",
                  },
                }}
              >
                <Tab.Screen
                  name="Driver"
                  component={AllParkingStation}
                  options={{
                    tabBarLabel: ({ focused }) => {
                      return (
                        <TouchableOpacity
                          style={{ width: 155 }}
                          onPress={() => handleBoxPressbtn(0)}
                        >
                          <Text
                            style={{
                              fontFamily: focused
                                ? AppFonts.OverpassBold
                                : AppFonts.OverpassRegular,
                              fontSize: 13,
                              alignSelf: "center",
                              textTransform: "none",
                              color: focused ? "#8F4300" : "#9C4900CC",
                            }}
                          >
                            All
                          </Text>
                        </TouchableOpacity>
                      );
                    },
                  }}
                />
                <Tab.Screen
                  name="DriverOnline"
                  component={SugestedParkStation}
                  options={{
                    tabBarLabel: ({ focused }) => {
                      return (
                        <TouchableOpacity
                          style={{ width: 195 }}
                          onPress={() => handleBoxPressbtn(1)}
                        >
                          <Text
                            style={{
                              fontFamily: focused
                                ? AppFonts.OverpassBold
                                : AppFonts.OverpassRegular,
                              fontSize: 13,
                              alignSelf: "center",
                              textTransform: "none",
                              color: focused ? "#8F4300" : "#9C4900CC",
                            }}
                          >
                            Suggested Parking Station
                          </Text>
                        </TouchableOpacity>
                      );
                    },
                  }}
                />
              </Tab.Navigator>
            </View>
          </View>
        </View> */}
      </ScrollView>
      )}
    </SafeAreaView>
  );
};

export default ParkStation;

const styles = StyleSheet.create({
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    padding: 8,
    width: "100%",
    // height: 40,
  },
  RegisterTxt: {
    // color: AppColors.brown,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  sty: {
    flexDirection: "row",
    marginVertical: 20,
  },
  hjhah: {
    height: height * 0.4,
  },
  mam: { flex: 1, position: "relative" },
  hjnshj: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 15,
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    zIndex: 1,
  },
  fleee: { flex: 1 },
});
